export enum OperationType {
    Add = 1,
    Edit = 2,
    Delete = 3,
}